@if (componentRequest) {
<div class="dialogContainer">
  <div class="dialogHeader">
    <img
      class="closeButton"
      src="/images/closeIconWithoutBox.png"
      (click)="closeDialog()"
    />
  </div>
  <div class="dialogContent">
      <app-dialog-input-title title="Type nummer"
                              [required]="true"></app-dialog-input-title>
      <input type="text" [(ngModel)]="componentRequest.typeNumber" />
      <app-dialog-input-title title="Gruppe"
                              [required]="true"></app-dialog-input-title>
      <select [(ngModel)]="componentRequest.group">
        @for (group of groupEnum; track group) {
        <option [ngValue]="group.value">
          {{ group.name }}
        </option>
        }
      </select>
      <app-dialog-input-title title="Kunde"
                              [required]="true"></app-dialog-input-title>
      <select [(ngModel)]="componentRequest.clientId"
              (ngModelChange)="clientCascade($event)">
          <option value="0" class="hidden">Vælg Kunde</option>
          @for (client of clients; track client.id) {
          <option [ngValue]="client.id">
              {{ client.name }}
          </option>
          }
      </select>
      @if(componentRequest.clientId > 0 && shownPlants.length > 0){
      <app-dialog-input-title title="Anlæg"
                              [required]="true"></app-dialog-input-title>
      <select [(ngModel)]="componentRequest.plantId">
          <option value="null" class="hidden">Vælg Anlæg</option>
          @for (plant of shownPlants; track plant.id) {
          <option [ngValue]="plant.id">
              {{ plant.plantName }}
          </option>
          }
      </select>
      }
      <app-dialog-input-title title="Beskrivelse"></app-dialog-input-title>
      <input type="text" [(ngModel)]="componentRequest.description" />

      <app-dialog-input-title title="Fw version"></app-dialog-input-title>
      <input type="text" [(ngModel)]="componentRequest.fwVersion" />

      <app-dialog-input-title title="Sw version"></app-dialog-input-title>
      <input type="text" [(ngModel)]="componentRequest.swVersion" />

      <app-dialog-input-title title="Fabrikant"></app-dialog-input-title>
      <input type="text" [(ngModel)]="componentRequest.vendor" />
  </div>
  <div class="dialogFooter">
    <app-save-button
      [disabled]="
        componentRequest.typeNumber == '' ||
        componentRequest.clientId == 0 ||
        componentRequest.plantId == 0
      "
      [clickEvent]="saveChanges.bind(this)"
    >
    </app-save-button>
    @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin) {
    <app-delete-button [clickEvent]="deleteEntry.bind(this)">
    </app-delete-button>
    }
  </div>
</div>
}
